<template>
  <div>
    <!-- A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
    <div
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'a4-standard-portrait-page':'a4-standard-landscape-page':field.temp_prop.paper_size==1?field.temp_prop.orientation==0?'a5-standard-portrait-page':'a5-standard-landscape-page':''"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    >
      <div
        class="print-template"
        :style="{'font-size':(field.temp_prop.font_size||8)+'pt','color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000','background':field.temp_prop.hasOwnProperty('bg_color')&&field.temp_prop.bg_color.show?field.temp_prop.bg_color.value.hex:'#fff'}"
      >
        <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
          <div>
            <!-- Max width for Logo Block -->

            <!-- Logo Image -->
            <img
              v-if="field.header_prop.show_logo && org_details.org_logo != null && org_details.org_logo  != ''"
              v-bind:src="imageSrc"
              :style="{'width':field.header_prop.logo_width+'px','height':field.header_prop.logo_height+'px'}"
              style="max-width:300px;max-height:183.05px;padding-bottom:5px !important"
            />
          </div>
          <div class="invoice-first-block" style="display:flex;justify-content: space-between;">
            <!-- Organization Details -->
            <div>
              <div
                v-if="field.header_prop.show_org_name"
                :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
                style="margin-bottom:1px;font-weight:500;"
              >{{ org_details.comp_name }}</div>

              <div
                v-if="field.header_prop.show_org_addr"
                class="custom-invoice-address"
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
              >
                <p>{{ org_details.addr_line_1 }}</p>
                <p>{{ org_details.addr_line_2 }}</p>
                <p>{{ org_details.org_city }}</p>
                <p>
                  {{
                  getDetails(
                  $AppDetails.state_details,
                  org_details.org_state,
                  "state_name"
                  )
                  }}
                </p>
                <p>
                  {{
                  getDetails(
                  $AppDetails.country_details,
                  org_details.org_country,
                  "country_name"
                  )
                  }}
                  {{ org_details.org_pincode }}
                </p>
                <p>{{ org_details.org_mail }}</p>
                <p>{{field.header_prop.phone}}: {{ org_details.phone_no}}</p>
                <p
                  v-if="org_details.gst_type != 3 &&org_details.gst_no!= ''"
                >GSTIN: {{ org_details.gst_no }}</p>
              </div>
            </div>
            <div v-if="field.header_prop.show_status_stamp" style="padding-top:30px">
              <span class="stamp is-approved">
                {{getPresentValue(
                list.retainer_status,
                "retainer_status_id",
                list.header_details.retainer_status_id,
                "retainer_status_name"
                )}}
              </span>
            </div>
            <div class="invoice-details">
              <!--  invoice details -->
              <h5
                v-if="field.header_prop.show_doc_title"
                :style="{'font-size':field.header_prop.doc_title_size+'pt','color':field.header_prop.doc_title_color.hex}"
                style="margin-bottom:10px !important"
                class="text-center invoice-top-heading"
              >{{field.header_prop.doc_title}}</h5>
              <table class="float-right invoice-details">
                <tbody>
                  <tr class="text-right pr-0 pb-0 pt-0">
                    <td
                      style="font-size:8pt"
                      class="fw-semi-bold pb-0 pt-0 pr-0"
                    >Deposit: {{ list.header_details.retainer_no }}</td>
                  </tr>
                  <tr class="text-right pr-0 pb-0 pt-0">
                    <td class="fw-semi-bold pb-0 pt-4 pr-0" style="font-size:8pt">Balance Due</td>
                  </tr>
                  <tr>
                    <td class="fw-semi-bold pb-0 pt-0 pr-0 text-right">
                      {{
                      currency_symbol +
                      " " +
                      parseFloat(
                      list.header_details.due_amount
                      ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      })
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Organization Logo -->
          </div>

          <div style="border-top:1px solid #ededed;margin-bottom:5px;"></div>
          <div class="invoice-second-block" style="display:flow-root">
            <div style="display:flex;justify-content: space-between;">
              <!--  organization detail -->
              <div v-if="field.header_prop.doc_bill_to.show">
                <div
                  style="margin-bottom:1px;font-weight:500;word-break: break-word !important;width:180px !important',font-size:8pt"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                >{{field.header_prop.doc_bill_to.label}}</div>
                <div
                  :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                  style="margin-bottom:1px;font-weight:500;word-break: break-word !important"
                >{{ list.header_details.cus_name }}</div>

                <div
                  class="custom-invoice-address"
                  style="word-break: break-word !important"
                  v-if="
                                  typeof list.retainer_details_address[1] !==
                                  'undefined'
                                "
                >
                  <p>
                    {{
                    list.retainer_details_address[1]
                    .cus_addr_line_1
                    }}
                  </p>
                  <p>
                    {{
                    list.retainer_details_address[1]
                    .cus_addr_line_2
                    }}
                  </p>
                  <p>
                    {{
                    getDetails(
                    $AppDetails.state_details,
                    list.retainer_details_address[1]
                    .cus_state,
                    "state_name"
                    )
                    }}
                  </p>
                  <p>
                    {{
                    getDetails(
                    $AppDetails.country_details,
                    list.retainer_details_address[1]
                    .cus_country,
                    "country_name"
                    )
                    }}
                  </p>
                  <p>{{ list.header_details.cus_mail }}</p>
                  <p>Ph: {{ list.header_details.cus_ph_no_1 }}</p>
                  <p
                    class="mb-1"
                    v-if="
                                  list.header_details.cus_gst_type == 1 ||
                                  list.header_details.cus_gst_type == 7 ||
                                  list.header_details.cus_gst_type == 2 ||
                                  list.header_details.cus_gst_type == 4
                                "
                  >GSTIN:{{ list.header_details.cus_gst_no }}</p>
                </div>
              </div>
              <div style="padding-top:20px !important">
                <table class="custom-invoice-details-table">
                  <tbody>
                    <tr v-if="field.header_prop.doc_date.show">
                      <td
                        style="word-break: break-word !important,font-size:8pt"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_date.label}}:</td>
                      <td
                        class="text-right"
                        style="word-break: break-word !important"
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                      >
                        {{
                        getDateFormat(
                        list.header_details.retainer_date
                        )
                        }}
                      </td>
                    </tr>
                    <tr v-if="field.header_prop.doc_ref_no.show&&list.header_details.ref_no">
                      <td
                        style="word-break: break-word !important,font-size:8pt"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_ref_no.label}}:</td>
                      <td
                        :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                        class="text-right"
                        style="word-break: break-word !important"
                      >{{ list.header_details.ref_no }}</td>
                    </tr>
                    <tr
                      v-for="(custom_field,index) in retainer_settings_details.custom_field"
                      v-if="
                      custom_field.print_show == 1 &&
                      custom_field.status == 1 && custom_field.permissions != 'hide' &&
                      list.header_details[
                      custom_field.field_name
                        ]"
                      :key="custom_field.index"
                        >
                                    <td
                                      class="fw-semi-bold pb-0 pt-1"
                                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                                    >{{ custom_field.label_name }}:</td>
                                    <td
                                      class="text-right pr-0 pb-0 pt-1"
                                      v-if="custom_field.datatype == 'select'"
                                       :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                                      style="width:150px !important;word-break-break-word"
                                    >
                                      {{
                                      getJsonPresentValue(
                                      custom_field.options,
                                      "value",
                                      list.header_details[
                                      custom_field.field_name
                                      ],
                                      "label"
                                      )
                                      }}
                                    </td>
                                    <td
                                      class="text-right pr-0 pb-0 pt-1"
                                       :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                                      v-else-if="
                                        custom_field.datatype == 'date'
                                      "
                                    >
                                      {{
                                      getDateFormat(
                                      list.header_details[
                                      custom_field.field_name
                                      ]
                                      )
                                      }}
                                    </td>
                                    <td
                                      class="text-right pr-0 pb-0 pt-1"
                                       :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                                      v-else-if="
                                        custom_field.datatype == 'amount'
                                      "
                                    >
                                      {{
                                      orgCurrencySymbol+' '+
                                      list.header_details[
                                      custom_field.field_name
                                      ]
                                      }}
                                    </td>
                                    <td
                                      class="text-right pr-0 pb-0 pt-1"
                                       :style="{'color':(field.temp_prop.font_color.hex||'#000')}"
                                      v-else
                                      style="width:150px !important;word-break-break-word"
                                    >
                                      {{
                                      list.header_details[
                                      custom_field.field_name
                                      ]
                                      }}
                                    </td>
                                  </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="invoice-fifth-block" style="margin-top:15px;">
            <table
              style="width:100%"
              :style="{'border-bottom':field.inv_details.layout.table_border.show+'px'+' solid '+field.inv_details.layout.table_border.value.hex}"
            >
              <thead
                class="semi-bold"
                :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
                style="word-break:break-word"
              >
                <th
                  v-if="field.item_prop.label.item_no.show"
                  :style="{'width':field.item_prop.label.item_no.width+'%'}"
                  class="text-right semi-bold"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.item_no.label}}</th>

                <th
                  :style="{'width':(field.item_prop.label.desc.width)+'%'}"
                  class="text-left semi-bold pl-4"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.desc.label}}</th>
                <!-- <th
                 style="word-break: break-word !important"
                v-for="(custom,index) in pdt_settings_details.custom_field.filter(x=>x.print_show==1)"
                :key="index"
                  :style="{'width':field.item_prop.label.custom_field.width+'%'}"
                  class="text-left semi-bold"
                  v-if="field.item_prop.label.custom_field.show"
                >{{custom.label_name}}</th>-->
                <th
                  :style="{'width':field.item_prop.label.amt.width+'%'}"
                  class="text-right semi-bold"
                  style="word-break: break-word !important;min-width:80px"
                >{{field.item_prop.label.amt.label}}</th>
              </thead>
              <tbody
                :style="{'font-size':(field.item_prop.layout.item_row_font_size||8)+'pt','background':field.item_prop.layout.hasOwnProperty('item_row_bg_color')&&field.item_prop.layout.item_row_bg_color.show?field.item_prop.layout.item_row_bg_color.value.hex:'#fff'}"
              >
                <tr v-for="(item, index) in list.item_details" :key="item.id">
                  <td
                        :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.hasOwnProperty('item_row_font_color')?field.item_prop.layout.item_row_font_color.hex:'#000'}"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-right"
                    style="vertical-align:top"
                  >{{ index + 1 }}</td>
                  <td
                    class="text-left pl-4"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.item_font_color.hex}"
                  >
                    <span
                      v-if="field.item_prop.label.desc.show"
                      style="display:block;word-break:break-word"
                    >{{ item.retainer_desc }}</span>
                  </td>
                  <!-- <td
                v-for="(custom,index) in pdt_settings_details.custom_field.filter(x=>x.print_show==1)"
                :key="index"
                  :style="{'width':field.item_prop.label.custom_field.width+'%'}"
                  class="text-left semi-bold"
                  v-if="field.item_prop.label.custom_field.show"
                  style="vertical-align:top !important;display:table-cell !important;word-break: break-word !important"
                  >{{item[custom.field_name]}}</td>-->

                  <td
                    class="text-right"
                    :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.hasOwnProperty('item_row_font_color')?field.item_prop.layout.item_row_font_color.hex:'#000'}"
                  >
                    {{
                    currency_symbol +
                    " " +
                    parseFloat(item.retainer_amt)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="field.total_prop.label.show_total_sec"
            class="invoice-sixth-block"
            style="display: flow-root;padding-top:23px !important"
          >
            <table
              class="custom-invoice-total-table float-right"
              style="width:100%;word-break:break-word"
            >
              <tbody>
                <tr>
                  <td
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >{{field.total_prop.label.total}}</td>
                  <td
                    style="width:150px;padding-right: 8px !important"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >
                    <span
                      :class="{'float-right':field.total_prop.label.currency_syb==2}"
                    >{{currency_symbol}}</span>
                    {{
                    parseFloat(
                    list.header_details.retainer_total
                    ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    })
                    }}
                  </td>
                </tr>
                <template v-if="field.total_prop.label.show_pay_detail">
                  <tr style="background:#fff !important;">
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;"
                    >{{field.total_prop.label.pay_made}}</td>

                    <td
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;width:150px;padding-right: 8px !important;color:#f55d5d!important"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{currency_symbol}}</span>
                      (-) {{ parseFloat(
                      list.header_details.received_amount
                      ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      })}}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="font-style:italic;"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      class="text-right"
                    >{{field.total_prop.label.refund}}</td>
                    <td
                      style="font-style:italic;width:150px;padding-right: 8px !important"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      class="text-right"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{currency_symbol}}</span>
                      (+) {{parseFloat(
                      list.header_details.refund_amount
                      ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      })}}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="font-style:italic;"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                      class="text-right"
                    >{{field.total_prop.label.bal_due}}</td>
                    <td
                      style="font-style:italic;width:150px;padding-right: 8px !important"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                      class="text-right"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{currency_symbol}}</span>
                      {{ parseFloat(
                      list.header_details.due_amount
                      ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      })}}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="invoice-seventh-block" style="padding-top:20px !important">
            <div
              v-if="field.total_prop.label.show_amt_wrd"
              class="text-left semi-bold"
              style="word-break:break-word"
            >Total Amount (in words) : {{ total_in_words + " Only" }}</div>
            <div style="border-top:1px solid #ededed;margin-bottom:2px;"></div>
            <div class="text-right" :style="{'font-size':6+'pt'}">
              <i>E. & O.E</i>
            </div>
          </div>
          <div class="invoice-eigth-block" style="display: flow-root;">
            <div class="float-left" v-if="field.footer_prop.signature.show">
              <div
                class="semi-bold text-right mb-2"
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                style="word-break:break-word"
              >{{field.footer_prop.signature.label}}</div>
              <hr style="border-color:#000;margin-bottom:0px;margin-top: 1.5rem" />
              <div
                class="text-left"
                style="word-break:break-word"
              >{{field.footer_prop.signature.name}}</div>
            </div>
          </div>
          <!--End of  Eigth Block  -->

          <!-- Ninth Block -->
          <div
            class="invoice-ninth-block"
            v-if="field.footer_prop.show_term_con"
            style="padding-top:40px !important"
          >
            <div
              class="terms-conditions"
              :style="{'font-size':field.footer_prop.term_font_size+'pt'}"
            >
              <div
                class="semi-bold text-left"
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                style="word-break:break-word"
              >{{field.footer_prop.term_label}}</div>
              <div
                style="word-break: break-word;white-space:pre"
              >{{ list.header_details.retainer_terms_cndtn }}</div>
            </div>
          </div>
          <!--End of Ninth Block -->
          <!-- Tenth Block -->
          <div class="invoice-tenth-block">
            <div class="invoice-notes">
              <div
                class="text-center"
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                style="word-break:break-word"
              >{{field.footer_prop.note_label||''}}</div>
              <div
                :style="{'font-size':field.footer_prop.note_font_size+'pt'}"
                class="text-center"
                style="word-break:break-word;white-space:pre"
              >{{ list.header_details.retainer_notes }}</div>
            </div>
          </div>
        </div>
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff','color':field.footer_prop.hasOwnProperty('footer_color')?field.footer_prop.footer_color.hex:'#000','font-size':(field.footer_prop.footer_font_size||7)+'pt'}"
        ></div>
      </div>
    </div>
    <!-- End of A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { mapGetters, mapState } from "vuex";
import { number_to_words } from "@/mixins/NumberToWords";
export default {
  props: ["list", "printlabel", "showprintlabel", "currency_symbol"],
  data() {
    return {
      total_in_words: "",
      imageSrc: ""
    };
  },
  methods: {
    preview(eve) {
      this.field = JSON.parse(JSON.stringify(eve));
    },
    getPresentValue(arr, prop, val, return_prop) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][return_prop];
          break;
        }
      }
      return hasMatch;
    }
  },
  created() {
    this.imageSrc =
      this.org_details.org_logo != null && this.org_details.org_logo != ""
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : "";
    this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.header_details.cus_currency,
        "currency_code_number"
      ) +
      " " +
      number_to_words(
        this.list.header_details.retainer_total,
        this.getDetails(
          this.$AppDetails.currency_details,
          this.list.header_details.cus_currency,
          "currency_code_fraction"
        )
      );
  },
  mounted() {
    EventBus.$on("preview", this.preview); // to trigger the method from parentcomponent
  },
  computed: {
    ...mapState({
      field: state =>
        state.permission.print_settings_details["Customer Deposit"]
          .template_list
    }),

    // mix this into the outer object with the object spread operator
    ...mapGetters([
      "org_details",
      "retainer_settings_details",
      "orgCurrencySymbol",
      "pdt_settings_details"
    ])
  }
};
</script>



<style lang="scss" scoped>
// A4 STANDARD PORTRAIT CSS
// Bootstrap class
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
//Custom css
//A4 standard portrait
#a4-standard-portrait-page {
  width: 21cm;
  min-height: fit-content;
}
//A4 standard landscape //A4 spreadsheet landscape
#a4-standard-landscape-page {
  width: 29.7cm;
  min-height: fit-content;
}
//A5 standard portrait
#a5-standard-portrait-page {
  width: 14.8cm;
  min-height: fit-content;
}
//A5 spreadsheet portrait
#a5-standard-landscape-page {
  width: 21cm;
  min-height: fit-content;
}

#a4-standard-portrait-page .print-template {
  zoom: 115%;
}
#a4-standard-landscape-page .invoice-content-layout {
  zoom: 130%;
}

#a5-standard-landscape-page .print-template,
#a4-standard-landscape-page .print-template {
  zoom: 80%;
}

.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}
table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}
table.custom-invoice-total-table.float-right > tbody > tr > td {
  padding: 2px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table {
  border-collapse: collapse;
}
table.shipping-details-table td {
  border: 1px solid #ededed;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}
table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.label-invoice-tag {
  width: 100px;
}
</style>
